import { type ReactElement } from 'react';

import StaticPageLayout from '@/Layout/StaticPageLayout';

import styles from './index.module.scss';

type Props = {
  readonly children: React.ReactNode;
};

const FullWidthStaticLayout = ({ children }: Props) => {
  return (
    <StaticPageLayout>
      <div className={styles.container}>
        {children}
      </div>
    </StaticPageLayout>
  );
};

export default FullWidthStaticLayout;
